import styled from 'styled-components/macro';

import { breakpointsRefresh as breakpoints } from 'common/styles';

import { IconContainer } from '../icon/icon';

const handleBackgroundColor = ({ bgColor, transparent, active }) => {
  if (bgColor) return bgColor;

  if (transparent) {
    return active ? 'var(--color-background-is-active)' : 'transparent';
  }

  return 'var(--color-background-is-active)';
};

const handleBackgroundHoverColor = ({ bgHoverColor, transparent, active }) => {
  if (bgHoverColor) return bgHoverColor;

  if (transparent) {
    return active
      ? 'var(--color-active-hover)'
      : 'var(--color-background-hint)';
  }

  return 'var(--color-background-hint)';
};

export const BasicButton = styled.button`
  color: ${({ color }) => color || 'var(--color-text-darker)'};
  background-color: ${handleBackgroundColor};
  padding: 0.25em 0.75em;
  cursor: pointer;
  text-decoration: none;

  border: none;
  border-radius: var(--border-radius-md);

  font-size: inherit;
  white-space: pre;

  &:hover {
    background-color: ${handleBackgroundHoverColor};
    color: var(--color-text-darker);
  }

  ${({ float }) => float && `float: ${float};`}

  ${breakpoints.md} {
    padding: 0.35em 0.75em;
  }
  transition: background-color 0.2s, color 0.2s;

  &:disabled,
  &:disabled:hover,
  &[aria-disabled='true'] {
    cursor: default;
    color: ${props =>
      props.small ? 'var(--color-text-light)' : 'var(--color-text-lighter)'};
    background-color: ${props =>
      props.small ? 'transparent' : 'var(--color-background-hint)'};
    ${IconContainer} {
      color: ${props =>
        props.small ? 'var(--color-text)' : 'var(--color-text-light)'};
    }
  }
  &:active,
  &:focus,
  &:hover {
    outline: 0;
    text-decoration: none;
  }

  ${IconContainer} {
    vertical-align: middle;
  }

  // & + & {
  //   margin-left: 1rem;
  // }
`;

export const LabelContainer = styled.span`
  padding-left: 0.5em;
  padding-right: 0.5em;
  vertical-align: middle;
`;
